import { render, staticRenderFns } from "./ApexStacked.vue?vue&type=template&id=0aca6bfb&scoped=true"
import script from "./ApexStacked.vue?vue&type=script&lang=js"
export * from "./ApexStacked.vue?vue&type=script&lang=js"
import style0 from "./ApexStacked.vue?vue&type=style&index=0&id=0aca6bfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca6bfb",
  null
  
)

export default component.exports